module.exports = __webpack_public_path__ + "assets/img/schools-page-pj-panda.aef63aed.png";